import type { LanguageOption } from "./types";

export const LANGUAGES: LanguageOption[] = [
  { code: "tr-TR", label: "Turkish", nativeLabel: "Türkçe" },
  { code: "en-US", label: "English", nativeLabel: "English" },
  { code: "nl-BE", label: "Dutch", nativeLabel: "Nederlands" },
];

export const MAX_BOOK_SIZE = 250 * 1024 * 1024;
export const MAX_LOCAL_ARCHIVE_SIZE = 9 * 1024 * 1024 * 1024;
export const MAX_PDF_PAGES = 1_000;
export const MAX_EXTRACTED_TEXT = 8_000_000;

export const EMPTY_INSIGHT_MESSAGE =
  "Kitapta merak ettiğin bir kelimeye dokun. Çevirisi, okunuşu ve bağlamı burada belirsin.";
